<template lang="html">
    <div>
        <!-- TITLE AND ABSTRACT SECTION START -->
        <section>
            <!-- title section -->
            <div class="row" style="padding: 0px 10px;">
                <h2>
                    Title and Abstract
                </h2>

                <div class="col-md-12 form-group">
                    <label class="asterik" for="fname">
                        Title
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="article.title"
                        required="required" />
                </div>
            </div>
        </section>

        <!-- abstract section -->
        <label
            v-bind:class="{
                'asterik': !article.section.abstracts_disabled
            }">
            Abstract
        </label>

        <div class="author-metadata mt-0">
            <div class="row content-padding abstract" ref="abstract">
                {{ 'structure: ' + article.abstracttype }}
                <form class="col-md-12">
                    <template v-if="article.section && article.section.abstracts_disabled == 0">
                        <label>
                            <input
                                type="radio"
                                id="structuredAbstract"
                                name="abstractType"
                                value="structured"
                                v-model="article.abstracttype" />
                            <b>
                                Structured (Preferred)
                            </b>
                            <span class="radio"></span>
                            <p>
                                Use for original paper, systematic review or consensus paper.
                                <b>
                                    Maximum 450 words
                                </b>
                            </p>
                        </label>

                        <label>
                            <input
                                type="radio"
                                id="unstructuredAbstract"
                                name="abstractType"
                                value="unstructured"
                                v-model="article.abstracttype" />
                            <b>
                                Unstructured
                            </b>
                            <span class="radio"></span>
                            <p>
                                Use for proposals, comments, tutorials, reviews, etc.
                                <b>
                                    Maximum {{ unstructuredWordCount }} words
                                </b>
                            </p>
                        </label>

                        <div v-if="article.abstracttype == 'structured'">
                            <div class="form-group">
                                <div v-for="abstract of article.abstracts">
                                    <label class="asterik">
                                        {{ abstract.section | ucfirst }}
                                    </label>
                                    <textarea
                                        class="form-control"
                                        style="height: 150px"
                                        v-bind:id="abstract.section"
                                        v-model="abstract.text">
                                    </textarea>
                                    <p style="text-align: right">
                                        {{ getWordCount() }} / {{ structuredWordCount }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="article.abstracttype == 'unstructured'">
                            <div class="form-group">
                                <textarea
                                    id="unstructured abstract"
                                    class="form-control"
                                    style="height: 500px"
                                    required="required"
                                    v-model="article.abstract">
                                </textarea>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <p>Abstracts are not used for this section.</p>
                    </template>
                </form>
            </div>
        </div>

        <div class="form-group">
            <label for="keywords">
                Keywords
            </label>
            <p>
                Choose terms that best describe the submission's content
                following the categories used by this journal, and examples
                provided by the editor. Separate terms with a semi-colon
                (term1; term2; term3).
            </p>
            <input
                type="text"
                id="keywords"
                class="form-control"
                placeholder="Keywords"
                v-model="this.article.subject_class" />
        </div>

        <button
            type="button"
            class="btn-custom btn-custom-green"
            style="display: block; margin: 1rem 0px 0px auto;"
            v-on:click="saveMetadata()">
            <i class="fal fa-save"></i> Save non-author metadata
        </button>

    </div>
</template>

<script>
export default {
    props: ["article"],
    filters: {
        ucfirst: value => {
            return value[0].toUpperCase() + value.substring(1);
        }
    },
    data() {
        return {
            structuredWordCount: 450,
            unstructuredWordCount: 500
        };
    },
    methods: {
        hasError() {},
        getWordCount() {
            let count = 0;

            for (let abstract of this.article.abstracts) {
                count += abstract.text.split(' ').length;
            }

            return count;
        },
        async saveMetadata() {
            let result = null;

            try {
                result = (await axios.post(
                    `/api/articles/${this.article.article_id}`,
                    this.article
                )).data;
            } catch (e) {
                // Fail silently
            }

            if (!result || !result.status) {
                this.showToast(
                    'There was an error saving the metadata.',
                    'Error',
                    'error'
                );

                console.log('ERROR !!!', result);
                return;
            }

            this.showToast('The metadata was saved successfully.');
        },
        showToast: function(message, title = 'Success', variant = 'success') {
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: true
            });
        }
    },
    created() {
        console.log(this.article);
    }
};
</script>

<style lang="css" scoped>
i {
    color: white;
}
</style>
